import { isSupportedCountry, parsePhoneNumberFromString } from "libphonenumber-js";

/** E.164 allows 15 digits in total: the country code counts towards them, the "+" does not. */
const E164_MAX_DIGITS = 15;

/**
 * Whether the backend accepts a salon phone number: `toE164` in
 * `@app/common/phone` parses it for the salon's country, so national formats
 * with spaces or a leading 0 are fine, and caps it at 15 digits.
 */
export function isValidSalonPhone(value: string, country: string): boolean {
  if (!isSupportedCountry(country)) {
    return false;
  }
  const parsed = parsePhoneNumberFromString(value, country);
  if (!parsed?.isValid()) {
    return false;
  }
  return parsed.number.replace(/\D/g, "").length <= E164_MAX_DIGITS;
}
